import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { Navbar } from "../../Components/Navbar/Navbar";
import { Meta } from "../../Components/Helpers/Meta";
import { useParams, Link } from "react-router-dom";
import InvestorSidebar from "../../Components/InvestorSidebar/InvestorSidebar";
import { Announcements } from "./Announcements";
import "./Announcements.style.css";

const SpecialAnnouncements = () => {
  const { t } = useTranslation();
  const { lang } = useParams();
  const L = i18next.language?.startsWith("tr") ? "tr" : "en";
  const isTR = L === "tr";

  // dd.mm.yyyy -> Date
  const parseDate = (d) => {
    const [dd, mm, yyyy] = d.split(".").map(Number);
    return new Date(yyyy, (mm || 1) - 1, dd || 1);
  };

  // Sadece özel durum açıklamaları
  const specials = Announcements
    .filter((a) => a.is_special)
    .sort((a, b) => parseDate(b.date) - parseDate(a.date));

  // TR + external_link_tr var -> harici link; aksi halde dahili route
  const normalizeHref = (u) => {
    if (!u) return "";
    return u.startsWith("http://") || u.startsWith("https://") ? u : `https://${u}`;
  };

  const resolveLink = (a) => {
    if (isTR && a.external_link_tr) {
      return { external: true, href: normalizeHref(a.external_link_tr) };
    }
    const href = isTR
      ? `/${L}/duyurular/${a.link_tr || a.link}`
      : `/announcements/${a.link || a.link_tr}`;
    return { external: false, href };
  };

  const titleFor = (a) => (isTR ? (a.title_tr || a.title) : (a.title || a.title_tr));

  // Yıla göre grupla (yyyy string'ine göre)
  const byYear = specials.reduce((acc, a) => {
    const year = (a.date?.split(".")[2] || "").trim();
    if (!year) return acc;
    (acc[year] ||= []).push(a);
    return acc;
  }, /** @type {Record<string, typeof specials>} */ ({}));

  const yearsDesc = Object.keys(byYear)
    .sort((a, b) => Number(b) - Number(a));

  return (
    <div>
      <Meta
        title={t("special-announcements") || "Special Announcements"}
        description={t("special-announcements") || "Special Announcements"}
        lang={lang}
      />
      <Navbar />

      <div className="c-wrapper">
        <div className="c-hero">
          <div className="c-hero-background">
            <picture>
              <img
                className="c-hero-image"
                alt=""
                src={require("../../assets/hero/public-offering.jpg")}
                style={{ width: "100%" }}
              />
            </picture>
          </div>
          <div className="c-hero-body">
            <div className="c-about-caption">
              <div className="c-caption-section" style={{ color: "#000", textAlign: "center" }}>
                {t("investor-relations")}
              </div>
              <h1 className="c-caption-header" style={{ color: "#000" }}>
                {t("special-announcements") || "Special Announcements"}
              </h1>
            </div>
          </div>
        </div>

        <div className="po-container">
          <InvestorSidebar />

          <main className="pol-content">
            {yearsDesc.map((year) => (
              <section key={year} className="pol-card">
                {/* Yıl başlığı (GA sayfasındaki başlık stiliyle uyumlu olsun diye ga-year sınıfını da ekliyorum) */}
                <div className="ga-year">{year}</div>

                <table
                  className="ann-table"
                  aria-label={`${t("special-announcements") || "Special Announcements"} - ${year}`}
                >
                  <tbody>
                    {byYear[year].map((a) => {
                      const link = resolveLink(a);
                      const key = `${year}-${a.link || a.link_tr || a.title}`;
                      return (
                        <tr key={key} className="ann-row">
                          <td className="ann-td ann-td--date">{a.date}</td>
                          <td className="ann-td ann-td--title">
                            {link.external ? (
                              <a
                                href={link.href}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="ann-rowlink"
                              >
                                {titleFor(a)}
                              </a>
                            ) : (
                              <Link to={link.href} className="ann-rowlink">
                                {titleFor(a)}
                              </Link>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </section>
            ))}
          </main>
        </div>
      </div>
    </div>
  );
};

export default SpecialAnnouncements;
